import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=709bcf18&scoped=true&"
import script from "./CustomTable.vue?vue&type=script&lang=js&"
export * from "./CustomTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=709bcf18&prod&scoped=true&lang=css&"
import style1 from "./CustomTable.vue?vue&type=style&index=1&id=709bcf18&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709bcf18",
  null
  
)

export default component.exports